<template>
	<transition name="modal">
       <div class="modal-mask deleteModal">
         <div class="modal-wrapper">
            <div class="modal-container">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Add/Remove campaign from Product</h5>
				</div>
				<div class="modal-body" v-if="!showLoader">
					<div class = "mso-popover-style" v-if ="doNotShowAdd">
						<p style = "font-size : 20px">Add</p>
						<div class = "radio-padding">
							<span >
								<input type = "radio"  value = "select" v-model = "add" >
								Select
							</span>
							<div v-if = "showAllProductList" v-for = "(item,k) in productListArray" class ="checkbox-padding">
								<span v-if ="!item.checked"><input type = "checkbox"  :value = "item.id" v-model = "addedProduct">
									{{item.product_title}}
								</span>
							</div>
						</div>
						<div>
							<span class = "radio-padding">
								<input type = "radio"  value = "all" v-model = "add" >
								Add All
							</span>
						</div>
					</div>
					<div class = "mso-popover-style" v-if = "cannotRemove" style = "color : red"><p>{{msg}}</p></div>
					<div class = "mso-popover-style" v-if ="doNotShowRemove">
						<p style = "font-size : 20px">Remove</p>
						<div class = "radio-padding">
							<span>
								<input type = "radio"  value = "select" v-model = "remove" >
								Select
							</span>
							<div v-if = "showAllProductListRemove" v-for = "item in removeProductlist" class ="checkbox-padding">
								<span><input type = "checkbox"  :value = "item.id" v-model = "removedProduct" >
									{{item.product_title}}
								</span>
							</div>
						</div>
						<div>
							<span class = "radio-padding">
								<input type = "radio"  value = "all" v-model = "remove" >
								Remove All
							</span>
						</div>
					</div>
				</div>
				<div class="row" style ="padding-top : 10px" v-if="showLoader">
					<div
					class="spinner-border"
					style="margin:40px auto;display:block;"
					></div>
				</div>
				 <div class="modal-footer" style = "display: flex ; justify-content : center;">
					 <button type="button" class="btn btn-secondary" @click = "closeModal()">No</button>
					 <button type="button" class="btn btn-primary" @click = "performAction()">Yes</button>
				 </div>
			 </div>
           </div>
         </div>
     </transition>
</template>

<script>
	export default{
		name : 'AddCampaignToProductPopUp',
		props:{
			data:Object,
		},
		data(){
			return{
				showAllProductList : false,
				showAllProductListRemove : false,
				productListArray : [],
				removeProductlist : [],
				add : "",
				remove : "",
				addedProduct :[],
				removedProduct : [],
				doNotShowRemove : true,
				doNotShowAdd : true,
				finalAddedList : [],
				finalRemovedList : [],
				showLoader:false,
				cannotRemove : false,
				msg : '',
				alreadyAddedList : []

			}
		},
		methods:{
			closeModal(){
				this.productListArray = [];
				this.add = "";
				this.remove = "";
				this.addedProduct = "";
				this.removedProduct = "";
				this.$emit('closePopUp')
			},
			performAction(){
				//
				let payloadObject = {}
				//
				if(!this.cannotRemove || this.removedProduct.length<1){
					this.showLoader = true;
				//	this.$store.commit('setSelectedVendorProduct',this.$route.params.vendorId)
				//	this.$store.commit('setSelectedBrandProduct',this.$route.params.brandId)
					if(this.addedProduct.length && this.removedProduct.length){
						payloadObject['campaignId'] = this.data.campaign_id
						payloadObject['ids'] = this.addedProduct
						this.$store.dispatch('campaign/addCampaignToProduct', { data: payloadObject}).then((res) => {
							let payload = {}
							payload['campaignId'] = this.data.campaign_id
							payload['ids'] = this.removedProduct
							this.$store.dispatch('campaign/removeProductsFromCampaign', { data: payload}).then((res) =>{
								this.$emit('getNewDataAndClose')
							})
						})
					}
					else if(this.addedProduct.length && this.removedProduct.length<1){
						payloadObject['campaignId'] = this.data.campaign_id
						payloadObject['ids'] = this.addedProduct
						this.$store.dispatch('campaign/addCampaignToProduct', { data: payloadObject}).then((res) => {
							this.$emit('getNewDataAndClose')

						})
					}
					else if(this.removedProduct.length && this.addedProduct.length<1){
						payloadObject['campaignId'] = this.data.campaign_id
						payloadObject['ids'] = this.removedProduct
						this.$store.dispatch('campaign/removeProductsFromCampaign', { data: payloadObject}).then((res) =>{
							this.$emit('getNewDataAndClose')
						})
					}
				  }
				}

		},
		mounted(){
			//
			let list = this.$route.params.products.split('+')
			let payload = {
				list : list,
				type : "multiple"
			}
			let vm = this;
			this.showLoader = true;
			this.$store.dispatch('product/getProductsForId',payload).then((res) => {
				vm.showLoader = false;
				vm.paramslist = res
				vm.productListArray = res
				if(vm.data.id){
					let list =vm.data.id.split(',');
					this.alreadyAddedList = list
					let selectedList = [];
					// if(vm.productListArray.length == list.length){
					// 	vm.doNotShowAdd = false
					// 	vm.productListArray.forEach((res) => {
					// 		vm.removeProductlist.push(res)
					// 		vm.remove = "select"
					// 	})
					// }
					//else{

					let flag = 0;
						vm.productListArray.forEach((res) => {
							list.forEach((result)=> {
								if(res.id == result){
									res.checked = true
									vm.removeProductlist.push(res)
									flag ++;
								}
							})
						})
						if(flag == vm.productListArray.length){
							vm.remove = "select"
							vm.doNotShowAdd = false
						}
						else{
							vm.add = "select"
						}

						if(vm.removeProductlist.length>0){
							vm.remove = "select"
						}
						else{
						//	vm.cannotRemove = true
							vm.doNotShowRemove = false
						}

						if(vm.removeProductlist.length == 1 && vm.alreadyAddedList.length == 1){
							this.msg = 'Can not remove as only only product in campaign'
							vm.cannotRemove = true
							vm.doNotShowRemove = false
						}



						// if(vm.removeProductlist.length == 1){
						// 	vm.cannotRemove = true
						// 	vm.doNotShowRemove = false
						// }
						// else{

						// }

					//}

				}
				else{
					vm.doNotShowRemove = false
				}
			})



			// if(list.length>0){
			// 	let added = []
			// 	this.remove = "select"
			// 	this.removedProduct = list
			// 	this.productList.map((response) => {
			// 	added = list.filter((res) => {
			// 		 return	response == res
			// 		})
			//
			// 	})
			//
			// 	if(added.length == this.productList.length){
			// 		this.doNotShowAdd = false
			// 		this.remove = "select"
			// 		this.removedProduct = added
			// 	}
			// 	else{
			// 		this.add = "select"
			// 		this.addedProduct = added
			// 	}
			// }
			// else{
			// 	this.doNotShowRemove = false
			// }

		},
		watch:{
			add(){
				//
				if(this.add == "select"){
					this.addedProduct = []
					this.showAllProductList = true
				}
				else{
					this.showAllProductList = false
					this.productListArray.forEach((res) => {
						if(!res.checked){
							this.addedProduct.push(res.id)
						}
				  })
				}

			},
			remove(){
				//

				if(this.remove == "select"){
					this.removedProduct = []
					this.showAllProductListRemove = true
				}
				else{
					this.showAllProductListRemove = false
					this.productListArray.forEach((res) => {
					this.removedProduct.push(res.id)
				  })
				}
				if((this.removeProductlist.length == this.alreadyAddedList.length) && (this.removedProduct.length == this.removeProductlist.length)){
					this.msg = 'Can not remove all as no product will be left in campaign'
					this.cannotRemove = true
				}
				else{
					this.cannotRemove = false
				}
				if(this.removeProductlist.length == 1 && this.alreadyAddedList.length == 1){
					this.msg = 'Can not remove as only only product in campaign'
					this.cannotRemove = true
					this.doNotShowRemove = false
				}

			},
			addedProduct(){
				//
			},
			removedProduct(){
				if((this.removeProductlist.length == this.alreadyAddedList.length) && (this.removedProduct.length == this.removeProductlist.length)){
					this.msg = 'Can not remove all as no product will be left in campaign'
					this.cannotRemove = true
				}
				else{
					this.cannotRemove = false
				}

				if(this.removeProductlist.length == 1 && this.alreadyAddedList.length == 1){
					this.msg = 'Can not remove as only only product in campaign'
					this.cannotRemove = true
					this.doNotShowRemove = false
				}

			}
		}
	}
</script>


<style lang="scss">

.deleteModal .mso-popover-style{
  /* display : flex;
  justify-content: center;
  align-items: center; */
}
/* .popover.fade.show.bs-popover-left {
   max-width : 310px !important
} */
.radio-padding{
	padding-left: 10px;
}
.checkbox-padding{
	padding-left: 20px;
}

.deleteModal {
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		display: table;
		transition: opacity .3s ease;
	}
	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}
	.modal-container {
		width: 100%;
		max-width : 800px;
		margin: 0px auto;
		padding-top:0px;
		background-color: #fff;
		border-radius: .3rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}
	.modal-enter {
		  opacity: 0;
	}
	.modal-leave-active {
		  opacity: 0;
	}
	.modal-title{
		text-align: center;
	}
}


.deleteModal .modal-enter .modal-container,
.deleteModal .modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
